import AuthService from "./AuthService";

class TokenService {
  getLocalAccessToken() {
    const userTorken = JSON.parse(localStorage.getItem("LoggedInUser") || "{}");
    return userTorken?.data?.token;
  }

  setUser(userObj: object) {
    localStorage.setItem("LoggedInUser", JSON.stringify(userObj));
    try {
      const obj = (userObj as any)?.data ?? (userObj as any) ?? {};
      const token =
        obj?.token ||
        obj?.Token ||
        obj?.accessToken ||
        obj?.access_token ||
        null;
      if (token && AuthService?.scheduleRefresh) {
        AuthService.scheduleRefresh(token);
      }
      if (!token && AuthService?.scheduleRefresh) {
        // ensure any existing timer is cleared when user set without token
        AuthService.scheduleRefresh(null);
      }
    } catch (e) {
      // ignore
    }
  }

  removeUser() {
    try {
      if (AuthService?.scheduleRefresh) AuthService.scheduleRefresh(null);
    } catch (e) {
      // ignore
    }
    localStorage.removeItem("LoggedInUser");
  }
  clearLocalAccessToken() {
    try {
      if (AuthService?.scheduleRefresh) AuthService.scheduleRefresh(null);
    } catch (e) {
      // ignore
    }
    localStorage.clear();
  }
  getLoggedInUserType() {
    const userTorken = JSON.parse(localStorage.getItem("LoggedInUser") || "{}");
    return userTorken?.data?.isSuperAdmin;
  }
  getLoggedInUserName() {
    const userTorken = JSON.parse(localStorage.getItem("LoggedInUser") || "{}");
    return userTorken?.data?.firstName + " " + userTorken?.data?.lastName;
  }

  getCustomerData() {
    const userTorken = JSON.parse(localStorage.getItem("LoggedInUser") || "{}");
    return userTorken?.data?.customers;
  }

  geUserMenu() {
    const userTorken = JSON.parse(localStorage.getItem("LoggedInUser") || "{}");
    return userTorken?.data?.customers;
  }

  geUserIdentity() {
    const userTorken = JSON.parse(localStorage.getItem("LoggedInUser") || "{}");
    return userTorken?.data?.identifier;
  }
}

export default new TokenService();
